export enum FilterOptionsCalendarEnum {
  today = 1,
  yesteday = 2,
  lastWeek = 3,
}
